import Accommodation from './Accommodation';
export default class AccommodationList {
  currency_rate!: number;
  checkin!: string;
  checkout!: string;
  items!: Accommodation[];

  constructor(data: undefined | any = {}) {
    this.currency_rate = data.currency_rate || 1;
    const { room_types = [] } = data;
    this.items = room_types.map((room) => new Accommodation(room));
  }
}
